module.exports = __webpack_public_path__ + "img/56_62.bdd8ce59.png";